import request from '@/utils/request'

let IndexApi = {

  /*基础配置*/
  base(data) {
    return request._get('/api/open/base', data);
  },

  /*商城首页*/
  getCount(data) {
    return request._post('/shop/Index/index', data);
  },
  getCounts(data) {
    return request._post('/shop/Index/indexs', data);
  },


}

export default IndexApi;



// WEBPACK FOOTER //
// ./src/api/index.js